import React, { useEffect } from "react";

import Footer from "../footer/footer";
import "./cookie-bot.scss";


const CookieBotPolicy = () => {
  const domainGroupId = 'bb0d601e-f391-4331-aee8-dc7e51d1538b';

  useEffect(() => {
    if (typeof window === "undefined" || !domainGroupId || !document) {
      return;
    }

    if (domainGroupId.length !== 36) {
      console.warn(
        `The cookie bot domain group id is ${domainGroupId.length} characters, instead it should be 36 characters!`
      );
      return;
    }

    const script = document.createElement("script");
    script.id = "CookieDeclaration";
    script.src = `https://consent.cookiebot.com/${domainGroupId}/cd.js`;
    script.type = "text/javascript";
    script.async = true;

    const cookiesPolicyDiv = document.getElementById("cookies-policy");
    if (cookiesPolicyDiv) {
      cookiesPolicyDiv.appendChild(script);
      document.body.style.overflow = "auto";
    }

    return () => {
      if (cookiesPolicyDiv) {
        cookiesPolicyDiv.removeChild(script);
        document.body.style.overflow = "";
      }
    };
  }, [domainGroupId]);

  return <div className={"cookies-policy-root"}>
    <div className={"cookies-policy-container"}>
      <div className={"cookies-policy-title-container"}>
        <span className={"cookies-policy-title"}>Política de cookies</span>
      </div>
      <div id="cookies-policy" />
    </div>
    <Footer />
  </div>;
};

export default CookieBotPolicy;
